import * as React from 'react';
import { useRef } from 'react';
import { V2C, fontBody } from './tokens';

interface V2ResumeBannerProps {
  onDismiss: () => void;
  savedAt?: string | null;
}

export default function V2ResumeBanner({ onDismiss, savedAt }: V2ResumeBannerProps) {
  function friendlyAgo(iso: string) {
    const ms = Date.now() - new Date(iso).getTime();
    const mins = Math.floor(ms / 60000);
    if (mins < 1) return 'just now';
    if (mins < 60) return `${mins}m ago`;
    const hrs = Math.floor(mins / 60);
    if (hrs < 24) return `${hrs}h ago`;
    return `${Math.floor(hrs / 24)}d ago`;
  }

  const ago = savedAt ? friendlyAgo(savedAt) : '';

  return (
    <div style={{
      margin: '8px 16px 0',
      background: V2C.bgAlt, border: `1px solid ${V2C.line}`, borderRadius: 10,
      padding: '6px 10px', display: 'flex', alignItems: 'center', gap: 8,
      animation: 'v2bannerIn 0.3s cubic-bezier(0.16,1,0.3,1)',
      fontSize: 11.5, color: V2C.mute, fontFamily: fontBody,
    }}>
      <span style={{ flex: 1, minWidth: 0, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
        Picked up where you left off{ago ? ` · saved ${ago}` : ''}
      </span>
      <button onClick={onDismiss} aria-label="Dismiss" style={{
        background: 'transparent', border: 'none', color: V2C.mute,
        cursor: 'pointer', fontSize: 16, padding: '0 2px', lineHeight: 1, flexShrink: 0,
      }}>×</button>
    </div>
  );
}
